import { UpdatableControlProgram } from "api/generated/model";
import { buildAccessRightsChangeset } from "utils/accessRights";
import { getIfChanged, diffToPresence } from "utils/diff";

import { ControlProgramFormSchema } from "./useControlProgramViewFormSchema";

export function toUpdatableControlProgram(
    oldData: ControlProgramFormSchema,
    newData: ControlProgramFormSchema
): UpdatableControlProgram {
    const accessRights = buildAccessRightsChangeset(
        oldData.accessRights,
        newData.accessRights
    );

    return {
        name: getIfChanged(oldData.name, newData.name),
        description: getIfChanged(oldData.description, newData.description),
        running: getIfChanged(oldData.running, newData.running),
        tags: diffToPresence(new Set(oldData.tagIds), new Set(newData.tagIds)),
        responsibleId:
            getIfChanged(oldData.responsibleId, newData.responsibleId) ??
            undefined,
        accessRights:
            Object.keys(accessRights).length !== 0 ? accessRights : undefined,
        controlEntityIds: diffToPresence(
            new Set(oldData.controlEntityIds.map((ce) => ce.entityId)),
            new Set(newData.controlEntityIds.map((ce) => ce.entityId))
        ),
    };
}
